import { createTheme } from '@mui/material/styles';

// Cuisine colors
export const cuisineColors = {
  italian: '#E63946', // Red
  japanese: '#FFB5C2', // Pastel pink
  indian: '#FF9933', // Saffron
  vegan: '#4CAF50', // Green
  // Add more cuisine colors as needed
};

// Neutral colors
export const neutralColors = {
  white: '#FFFFFF',
  gray50: '#F9FAFB',
  gray100: '#F3F4F6',
  gray200: '#E5E7EB',
  gray300: '#D1D5DB',
  gray400: '#9CA3AF',
  gray500: '#6B7280',
  gray600: '#4B5563',
  gray700: '#374151',
  gray800: '#1F2937',
  gray900: '#111827',
  black: '#000000',
};

// Typography
export const typography = {
  fontFamily: '"Inter", "SF Pro", "Roboto", sans-serif',
  h1: {
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.3,
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  body1: {
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
};

// Spacing
export const spacing = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  xxl: '3rem',
};

// Breakpoints
export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
};

// Create Material-UI theme
export const theme = createTheme({
  palette: {
    primary: {
      main: cuisineColors.italian,
    },
    secondary: {
      main: cuisineColors.japanese,
    },
    background: {
      default: neutralColors.white,
      paper: neutralColors.gray50,
    },
    text: {
      primary: neutralColors.gray900,
      secondary: neutralColors.gray600,
    },
  },
  typography,
  spacing: (factor: number) => `${0.25 * factor}rem`,
  breakpoints: {
    values: breakpoints,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        },
      },
    },
  },
});

// Dark theme
export const darkTheme = createTheme({
  ...theme,
  palette: {
    ...theme.palette,
    mode: 'dark',
    background: {
      default: neutralColors.gray900,
      paper: neutralColors.gray800,
    },
    text: {
      primary: neutralColors.white,
      secondary: neutralColors.gray400,
    },
  },
}); 